import * as React from "react";
import { Dimmer } from "semantic-ui-react";
import EditDomain from "../../Editing/EditDomain";
import Table from "../../../components/Table/Table";
import { setDomainEnumExtraProperties } from "../../../utils/pdApiUtils";
import { editActions } from "../../../actions/editActions";
import _ from "lodash";
import { mainActions } from "../../../actions/mainActions";
import { Filter } from "../../../components/Table/Migration/LegacyTypes";

/**
 * All the following props are passed from parent component
 */
export type DomainsTableProps = {
  pdApi: State.PdApi;
  columns: State.ColumnMap;
  mainState: State.Main;
  editedObjectId: number | undefined;
  isEditActive: boolean;
  editActions: typeof editActions;
  mainActions: typeof mainActions;
  subMenuRoute: State.EnumerationSubmenu;
  toggleModal: () => void;
  columnFilters: Filter[];
  setColumnFilters: (subMenuRoute: State.EnumerationSubmenu, columnFilter: Filter[]) => void;
};

type DomainsTableState = {
  isModalOpen: boolean;
};

export class DomainsTable extends React.Component<DomainsTableProps, DomainsTableState> {
  state = {
    isModalOpen: false
  };

  componentDidMount(): void {
    // make throttle function
    this.handleFilterChangeDebounced = _.debounce(this.handleFilterChangeDebounced, 500);
  }

  private handleFilterChangeDebounced = (changedFilters: Filter[]) => {
    this.props.setColumnFilters(this.props.subMenuRoute, changedFilters);
  };
  
  componentWillUnmount(): void {
    this.props.mainActions.setLastEditedObjectId(undefined);
  }
  render(): JSX.Element {
    const { columns, pdApi, mainState, isEditActive, toggleModal } = this.props;
    const { domains } = pdApi;
    const domainsAsArray = _.values(domains);
    const { editSize, pageSize, isShortenTextEnabled } = mainState;
    const rows: Api.AnyEnumeration[] = [...domainsAsArray]
      .sort(function (a: Api.Domain, b: Api.Domain) {
        return a.enumValue - b.enumValue;
      })
      .map(row => setDomainEnumExtraProperties(row as Api.Domain, pdApi));
    const selectedColumns: State.Column[] = columns.Domains;

    const startingPage = mainState.lastEditedObjectId
      ? (rows.findIndex(domain => domain.id === mainState.lastEditedObjectId) / // tslint:disable-line: no-bitwise
        mainState.pageSize) >>
      0
      : 0;
    return (
      <div className="flex-1">
        <div className="flex-1">
          <Table
            startingPage={startingPage}
            rows={rows}
            columns={selectedColumns}
            isHidingTextActive={isShortenTextEnabled}
            handleRowSelection={this.props.editActions.select}
            isRowSelected={this.isEnumerationSelected}
            pageSize={pageSize}
            handleFilterChange={this.handleFilterChangeDebounced}
          />
        </div>
        {isEditActive && (
          <Dimmer active={true} page={true}>
            <div className="edit-view" style={{ flex: editSize , width : editSize == 0.3 ? "500px" : "1000px" }}>
              <EditDomain {...this.props} toggleModal={toggleModal} />
            </div>
          </Dimmer>
        )}
      </div>
    );
  }

  /*
   * Returns status if enumeration has been selected
   * @param {Api.AnyEnumeration} parameter
   * @returns {boolean}
   */
  private isEnumerationSelected = (enumeration: Api.Domain): boolean => {
    const editedObjectId = this.props.editedObjectId ?? this.props.mainState.lastEditedObjectId;
    if (editedObjectId && enumeration.id === editedObjectId) {
      return true;
    } else {
      return false;
    }
  };
}

export default DomainsTable;
